import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllRoleRoleTypeEnum,
  RolesAndPrivilegesControllerApi,
} from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../utils/utils";

interface RolesParams {
  pagination: DGT_Pagination;
  status?: boolean;
  archive?: boolean;
  roleType?: GetAllRoleRoleTypeEnum[];
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 * to handle the roles and responsibilities list
 * @author rajkumar rathod
 */
export function getAllRoles(param: RolesParams): useBaseContent<any> {
  const prevPage = useRef<number>(param.pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination: param.pagination,
    searchKey: "",
    prevPage,
  });

  return useQuery({
    queryKey: ["roles-and-responsibilities-list", param],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: param.enabled ?? true,
    queryFn: async () =>
      new RolesAndPrivilegesControllerApi(getConfigObject())
        .getAllRole(
          pageIndex,
          param.pagination?.pageSize,
          undefined,
          undefined,
          param?.status,
          param?.archive,
          param?.roleType,
          param?.xTENANTID
        )
        .then((res) => res?.data),
  });
}
